import { Empty } from 'antd';

interface PlaceholderPageProps {
  title: string;
  hint?: string;
}

export default function PlaceholderPage({ title, hint }: PlaceholderPageProps) {
  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-[20px] font-semibold text-slate-900 m-0">{title}</h1>
        {hint && <p className="text-[13px] text-slate-500 mt-1 mb-0">{hint}</p>}
      </div>
      <div className="bg-white rounded-xl shadow-card border border-slate-100 p-16">
        <Empty
          description={
            <span className="text-slate-500">
              该页面骨架待 Phase 4 实现 · 参考 UI 原型实现 1:1 还原
            </span>
          }
        />
      </div>
    </div>
  );
}
